import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './FactButton.module.scss';
import classNames from 'classnames';
import {playAudio} from './mediaBundle';

export default class FactButton extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        inError: PropTypes.bool,
        onClick: PropTypes.func,
    };

    render() {
        const {label, disabled, className, errorKey, inError, onClick} = this.props;

        const buttonClassName = classNames(className, styles.factButton, {
            [styles.buttonError]: inError,
        });

        return (
            <button
                className={buttonClassName}
                disabled={disabled}
                onClick={() => {
                    playAudio('button');
                    onClick();
                }}
            >
                <div>{label}</div>
            </button>
        );
    }
}
